import React, { useState, useEffect } from 'react';
import { Users, Database, TrendingUp, Shield } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../services/api';
import Navbar from '../components/Layout/Navbar';
import './AdminPage.css';

export default function AdminPage() {
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => { fetchDashboard(); fetchUsers(); }, []);

  const fetchDashboard = async () => {
    try { const res = await api.get('/admin/dashboard'); setStats(res.data.stats); }
    catch { toast.error('Failed to load admin stats'); }
    finally { setLoading(false); }
  };

  const fetchUsers = async (q = '') => {
    try { const res = await api.get(`/admin/users?search=${q}&limit=20`); setUsers(res.data.users); }
    catch {}
  };

  const planColor = { free: '#7a7a9d', basic: '#00a3ff', pro: '#7c3aed', premium: '#00ff88' };

  return (
    <div className="admin-page">
      <Navbar />
      <div className="admin-body">
        <div className="admin-header"><Shield size={20} /><h1>Admin Dashboard</h1></div>

        {loading ? <div className="loading-screen"><div className="spinner" /></div> : (
          <>
            <div className="stats-grid">
              {[
                { icon: Users, label: 'Total Users', value: stats?.totalUsers || 0, color: '#00a3ff' },
                { icon: TrendingUp, label: 'Premium Users', value: stats?.premiumUsers || 0, color: '#00ff88' },
                { icon: Database, label: 'Total Projects', value: stats?.totalProjects || 0, color: '#7c3aed' },
                { icon: TrendingUp, label: 'Total Revenue', value: `₹${stats?.revenue || 0}`, color: '#ffc107' },
              ].map((s, i) => (
                <div key={i} className="stat-card">
                  <div className="stat-icon" style={{ color: s.color, background: s.color + '15' }}><s.icon size={20} /></div>
                  <div><div className="stat-value">{s.value}</div><div className="stat-label">{s.label}</div></div>
                </div>
              ))}
            </div>

            <div className="admin-section">
              <div className="section-header">
                <h2>Users</h2>
                <input className="input" placeholder="Search by name or email..." value={search}
                  onChange={e => { setSearch(e.target.value); fetchUsers(e.target.value); }}
                  style={{ width: '280px' }} />
              </div>
              <div className="users-table">
                <table>
                  <thead><tr><th>Email</th><th>Name</th><th>Plan</th><th>Uploads</th><th>Joined</th></tr></thead>
                  <tbody>
                    {users.map(u => (
                      <tr key={u._id}>
                        <td>{u.email}</td>
                        <td>{u.name || '—'}</td>
                        <td><span className={`badge badge-${u.plan}`}>{u.plan}</span></td>
                        <td>{u.uploadsThisMonth || 0}</td>
                        <td>{new Date(u.createdAt).toLocaleDateString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
